<div class="product-page__stock-info">
  @if (limitedQuantity > productStock! && productStock !== 0) {
    <p class="limited_quantity" i18n="@@ONLY_N_PRODUCTS_LEFT">There are only {{ productStock }} left!</p>
  }
  @if (productStock === 0) {
    <p i18n="@@NO_LONGER_AVAILABLE">No longer available</p>
  }
  @if (productStock! > 0 && productStock! > limitedQuantity) {
    <p i18n="@@SHIPMENT_MSG">The shipment can be completed within 4 days</p>
  }
</div>
